import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, ViewChild } from '@angular/core';
import { findOneById } from '@api/services/tariff';
import { ProductsService } from '@api/services/products';
import { AppState } from '../../app.service';
import { BasketAssistant } from '@api/services/basket';
import { leftPad, scrollTo } from '@api/utils';
import { TrackingBasket } from '@api/services/tracking';
import { ActionDialogComponent } from 'app/shared/components/action-dialog';
import config from '@api/config';
import { VoucherState } from "./voucher-code/voucher-code.component";
var BasketOverviewComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function BasketOverviewComponent(appState) {
        this.appState = appState;
        /**
         * Set our default values
         */
        this.localState = { value: '' };
        this.basketItems = {};
        this.basketItemKeys = [];
        this.objectKeys = Object.keys;
        this.lastModifiedDate = '';
        this.openDeleteItemsDialog = 'hidden';
        this.scrollTo = scrollTo;
        this.voucherState = VoucherState.Unknown;
        this.loadBasketItems = this.loadBasketItems.bind(this);
        this.reloadBasketItems = this.reloadBasketItems.bind(this);
        this.checkBasketItems = this.checkBasketItems.bind(this);
        this.handleConfirmDeleteItems = this.handleConfirmDeleteItems.bind(this);
        this.handleAbortDeleteItems = this.handleAbortDeleteItems.bind(this);
    }
    BasketOverviewComponent.prototype.ngOnInit = function () {
        this.loadBasketItems();
        this.loadDate();
        var checkoutContainer = document.getElementsByTagName("vfeo-checkout");
        var hotlineBannerIcon = checkoutContainer[0].getAttribute('data-hotline-banner-icon');
        this.hotlineBannerIcon = "/simplicity/svgdefs.svg#i-" + hotlineBannerIcon + "-lrg";
        this.hotlineBannerTxtDesktop = checkoutContainer[0].getAttribute('data-hotline-banner-txt-desktop');
        this.hotlineBannerTxtMobile = checkoutContainer[0].getAttribute('data-hotline-banner-txt-mobile');
        BasketAssistant.subscribe('itemsDeleted', this.loadBasketItems);
        BasketAssistant.subscribe('itemsAdded', this.loadBasketItems);
        BasketAssistant.subscribe('itemsRefreshed', this.reloadBasketItems);
        var tracking = new TrackingBasket();
        tracking.track();
    };
    BasketOverviewComponent.prototype.submitState = function (value) {
    };
    BasketOverviewComponent.prototype.loadDate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var date;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getLastModifiedDate()];
                    case 1:
                        date = _a.sent();
                        this.lastModifiedDate = leftPad(date.getDate(), 2) + "." + leftPad(date.getMonth() + 1, 2) + "." + date.getFullYear() + " um " + leftPad(date.getHours(), 2) + ":" + leftPad(date.getMinutes(), 2) + " Uhr";
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.loadBasketItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        _a.basketItems = (_b.sent());
                        this.basketItemKeys = Object.keys(this.basketItems);
                        this.checkBasketItems();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.reloadBasketItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.basketItemKeys = [];
                        this.basketItems = [];
                        _a = this;
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        _a.basketItems = (_b.sent());
                        this.basketItemKeys = Object.keys(this.basketItems);
                        this.checkBasketItems();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.applyVoucherCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.addOptionToAllItems(config.VOUCHER_DISCOUNT_ID)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.checkForVoucherCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.usesAnyItemOptionWithCode(config.VOUCHER_DISCOUNT_ID)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.removeVoucherCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.removeOptionFromAllItems(config.VOUCHER_DISCOUNT_ID)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.updateVoucherState = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            var applied, applied;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.voucherState = state;
                        if (!(this.voucherState === VoucherState.Success))
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, this.applyVoucherCode()];
                    case 1:
                        // apply VoucherCode to items in Basket
                        if (!(_a.sent())) {
                            this.voucherState = VoucherState.Error;
                        }
                        return [3 /*break*/, 9];
                    case 2:
                        if (!(this.voucherState === VoucherState.Unavailable))
                            return [3 /*break*/, 6];
                        return [4 /*yield*/, this.checkForVoucherCode()];
                    case 3:
                        applied = _a.sent();
                        if (!applied)
                            return [3 /*break*/, 5];
                        return [4 /*yield*/, this.removeVoucherCode()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 9];
                    case 6:
                        if (!(this.voucherState === VoucherState.Available))
                            return [3 /*break*/, 9];
                        return [4 /*yield*/, this.checkForVoucherCode()];
                    case 7:
                        applied = _a.sent();
                        if (!applied)
                            return [3 /*break*/, 9];
                        return [4 /*yield*/, this.applyVoucherCode()];
                    case 8:
                        _a.sent();
                        this.voucherState = VoucherState.Success;
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.checkBasketItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _i, itemKey, basketItem, componentSet, mandatoryServices, usedOptions, discounts, articleEntity, tariffEntity, _c, _d, component, e_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = [];
                        return [4 /*yield*/, this.basketItems];
                    case 1:
                        for (_b in _e.sent())
                            _a.push(_b);
                        _i = 0;
                        _e.label = 2;
                    case 2:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 12];
                        itemKey = _a[_i];
                        basketItem = this.basketItems[itemKey];
                        componentSet = [];
                        mandatoryServices = [];
                        usedOptions = [];
                        discounts = [];
                        articleEntity = void 0, tariffEntity = void 0;
                        _e.label = 3;
                    case 3:
                        _e.trys.push([3, 10, , 11]);
                        _c = 0, _d = basketItem.offer.components;
                        _e.label = 4;
                    case 4:
                        if (!(_c < _d.length))
                            return [3 /*break*/, 9];
                        component = _d[_c];
                        if (!(component.type === 'tariffMobile'))
                            return [3 /*break*/, 6];
                        return [4 /*yield*/, findOneById(component.subId ? component.subId : component.refId)];
                    case 5:
                        tariffEntity = _e.sent();
                        componentSet.push(tariffEntity);
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, ProductsService.findOneById(component.refId)];
                    case 7:
                        articleEntity = _e.sent();
                        componentSet.push(articleEntity);
                        _e.label = 8;
                    case 8:
                        _c++;
                        return [3 /*break*/, 4];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        e_1 = _e.sent();
                        console.log(e_1);
                        return [3 /*break*/, 11];
                    case 11:
                        _i++;
                        return [3 /*break*/, 2];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.resetBasket = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.removeAllItems()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.handleConfirmDeleteItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resetBasket()];
                    case 1:
                        _a.sent();
                        if (navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))) {
                            window.location.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketOverviewComponent.prototype.handleAbortDeleteItems = function () {
        this.openDeleteItemsDialog = 'hidden';
    };
    return BasketOverviewComponent;
}());
export { BasketOverviewComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/basket-overview/basket-overview.component.ts
// module id = null
// module chunks = 